import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import CallFlowsList from "../../call-flows/CallFlowsList";
import CallDispositionsPage from "../call-dispositions/CallDispositionsPage";
import CallScriptsPage from "../call-scripts/CallScriptsPage";
import PhoneNumbersContent from "./PhoneNumbersContent";
import A2pRegistrationForm from "./a2p/A2pRegistrationForm";
import AudioClipsTab from "./AudioClipsTab";
import VoicemailMessagesTab from "./VoicemailMessagesTab";
import TelephonySettingsTab from "./TelephonySettingsTab";

const TABS = [
  "phone-numbers",
  "call-flows",
  "dispositions",
  "call-scripts",
  "voicemail-messages",
  "audio-clips",
  "sms-registration",
  "settings",
] as const;
type Tab = (typeof TABS)[number];

export default function TelephonyPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab: Tab = TABS.includes(tabParam as Tab)
    ? (tabParam as Tab)
    : "phone-numbers";

  const setTab = (tab: string) => {
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Telephony</h1>
        <p className="text-muted-foreground">
          Manage phone numbers, call routing, and call dispositions
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setTab}>
        <div className="-mx-4 border-b border-border px-4 pb-4">
          <TabsList>
            <TabsTrigger value="phone-numbers">Phone Numbers</TabsTrigger>
            <TabsTrigger value="call-flows">Call Flows</TabsTrigger>
            <TabsTrigger value="dispositions">Dispositions</TabsTrigger>
            <TabsTrigger value="call-scripts">Call Scripts</TabsTrigger>
            <TabsTrigger value="voicemail-messages">Voicemail Messages</TabsTrigger>
            <TabsTrigger value="audio-clips">Audio Clips</TabsTrigger>
            <TabsTrigger value="sms-registration">SMS Registration</TabsTrigger>
            <TabsTrigger value="settings">Settings</TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="phone-numbers" className="mt-6">
          <PhoneNumbersContent />
        </TabsContent>

        <TabsContent value="call-flows" className="mt-6">
          <CallFlowsList />
        </TabsContent>

        <TabsContent value="dispositions" className="mt-6">
          <CallDispositionsPage />
        </TabsContent>

        <TabsContent value="call-scripts" className="mt-6">
          <CallScriptsPage />
        </TabsContent>

        <TabsContent value="voicemail-messages" className="mt-6">
          <VoicemailMessagesTab />
        </TabsContent>

        <TabsContent value="audio-clips" className="mt-6">
          <AudioClipsTab />
        </TabsContent>

        <TabsContent value="sms-registration" className="mt-6">
          <A2pRegistrationForm />
        </TabsContent>

        <TabsContent value="settings" className="mt-6">
          <TelephonySettingsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
